<template>
  <div>
    <div class="share-btn-group">
      <p class="share-string">{{ $t('main.SHARE_TO') }}</p>
      <div class="btn-group">
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/facebook?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/facebook.svg" alt="Facebook"
        /></a>
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/whatsapp?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/whatsapp.svg" alt="Whatsapp"
        /></a>
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/wechat?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/wechat.svg" alt="Wechat"
        /></a>
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/sina_weibo?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/weibo.svg" alt="Sina Weibo"
        /></a>
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/twitter?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/twitter.svg" alt="Twitter"
        /></a>
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/linkedin?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/linkedin.svg" alt="Linkedin"
        /></a>
        <a
          class="share-btn"
          target="_blank"
          :href="`https://www.addtoany.com/add_to/line?linkurl=${currentUrl}`"
          ><img src="/ics/property/img/share/line.svg" alt="Line"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    currentUrl() {
      return document.URL;
    },
  },
};
</script>

<style scoped>
.share-btn-group {
  width: 100%;
  padding-bottom: 12px;
  background: #ffffff;
}

.share-string {
  margin: 0;
  font-size: 18px;
  text-align: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.share-btn {
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 5px;
}

.share-btn > img {
  width: 32px;
  height: 32px;
}

.flex-content {
  display: flex;
  flex-flow: column;
}
</style>
